import { useEffect, useState } from 'react'

import { Box, Drawer, IconButton, Typography } from '@mui/material'
import { InnerHtml } from 'components/ui'
import { useMappedTranslation } from 'hooks'

type Props = {
  cookieAgreementCountry: string
  isSlideIn: boolean
  isDialogOpen: boolean
  handleSlide: (boolean) => void
  handleDialog: (boolean) => void
  handleSaEnableCookie: (boolean) => void
}
export default function CookieAgreementSlide({
  cookieAgreementCountry,
  isSlideIn,
  isDialogOpen,
  handleSlide,
  handleDialog,
  handleSaEnableCookie
}: Props) {
  const t = useMappedTranslation()

  const [isLAEuropeNotice, setIsLAEuropeNotice] = useState<boolean>(
    cookieAgreementCountry === 'EUROPE' || cookieAgreementCountry === 'LATIN_AMERICA'
  )

  useEffect(() => {
    if (cookieAgreementCountry === 'EUROPE' || cookieAgreementCountry === 'LATIN_AMERICA') {
      setIsLAEuropeNotice(true)
    } else {
      setIsLAEuropeNotice(false)
    }
  }, [cookieAgreementCountry])

  return (
    <Drawer
      anchor={'bottom'}
      open={isSlideIn && !isDialogOpen}
      sx={{
        '& .MuiDrawer-paper': {
          width: '100%',
          bgcolor: '#252525',
          maxHeight: '456px'
        }
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: '560px', md: '820px', lg: '1232px' },
          maxHeight: '60vh',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'row',
          padding: { xs: '24px 24px 20px', md: '36px 0 18px' }
        }}
      >
        <Box sx={{ width: '100%', minWidth: { xs: '312px', lg: '988px' } }}>
          <Typography sx={{ textAlign: 'left', fontSize: '20px', lineHeight: '24px', fontWeight: 700, color: 'gray.4' }}>
            {t('cookie.agreement.title')}
          </Typography>
          <Box sx={{ maxWidth: '1164px', width: '100%', margin: { xs: '18px 0 0 0', md: '16px 0 0 0' } }}>
            {isLAEuropeNotice && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <InnerHtml
                  sx={{
                    textAlign: 'left',
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: 500,
                    color: 'gray.4',
                    '& a': {
                      fontWeight: 'bold',
                      color: 'gray.4',
                      whiteSpace: 'nowrap'
                    }
                  }}
                >
                  {t('iam.01.Common.Txt.Our.site.uses.essential.cookies.only.See.our.PP.and.CP.for.more.information', {
                    0: '<a href="/policies/privacy-notices/latest">',
                    1: '</a>',
                    2: '<a href="/policies/cookie">',
                    3: '</a>'
                  })}
                </InnerHtml>
              </Box>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            maxWidth: { xs: '20px', md: '48px' },
            maxHeight: { xs: '20px', md: '48px' },
            margin: { xs: '0 0 0 -24px', md: '0 0 0 128px' }
          }}
        >
          <IconButton
            onClick={() => {
              handleSaEnableCookie(true)
              handleSlide(false)
            }}
            sx={{
              maxWidth: { xs: '20px', md: '48px' },
              maxHeight: { xs: '20px', md: '48px' }
            }}
            aria-label={t('iam.Accessibility.Button.Attribute.close')}
            data-testid='IconButton8A1DAC1C'
          >
            <Box
              component='img'
              alt=''
              src={'/assets/images/icons/close.svg'}
              sx={{ width: { xs: '20px', md: '48px' }, height: { xs: '20px', md: '48px' } }}
            />
          </IconButton>
        </Box>
      </Box>
    </Drawer>
  )
}
